import { Box, type BoxProps, Text } from 'ink';
import { Fragment } from 'react';
import type { KeyDetails } from './tableTypes';

/*
  See Table component
*/
export default function TableHead({
  keyDetails,
  ...props
}: BoxProps & {
  keyDetails: KeyDetails;
}) {
  let topLine = '┌';
  topLine += Object.values(keyDetails)
    .map(({ width }) => '─'.repeat(width + 2))
    .join('┬');
  topLine += '┐';

  const contentLineElements = Object.values(keyDetails).map(
    ({ key, width }, index) => {
      return (
        <Fragment key={key}>
          {index > 0 ? <Text> │ </Text> : null}
          <Box width={width}>
            <Text bold>{key}</Text>
          </Box>
        </Fragment>
      );
    },
  );

  return (
    <Box flexDirection="column" {...props}>
      <Box>
        <Text>{topLine}</Text>
      </Box>
      <Box>
        <Box>
          <Text>│ </Text>
          {contentLineElements}
          <Text> │</Text>
        </Box>
      </Box>
    </Box>
  );
}
